import { render, staticRenderFns } from "./CourseTemplates.vue?vue&type=template&id=4ad671af&scoped=true&"
import script from "./CourseTemplates.vue?vue&type=script&lang=js&"
export * from "./CourseTemplates.vue?vue&type=script&lang=js&"
import style0 from "./CourseTemplates.vue?vue&type=style&index=0&id=4ad671af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad671af",
  null
  
)

export default component.exports